import {
  setResultMax,
  useConnectorsFilter,
  useConnectorsSearch,
  useResultCount,
} from 'layout/Listing/variants/connectors/store';

const useFilteredConnectors = (connectors: Connector[]) => {
  const search = useConnectorsSearch();
  const filter = useConnectorsFilter();
  const resultCount = useResultCount();

  const sortedConnectors = connectors.sort((a, b) => a?.display?.label.localeCompare(b?.display?.label));

  const searchedConnectors = sortedConnectors.filter(connector =>
    connector?.display?.label.toLowerCase().includes(search.toLowerCase()),
  );

  const filteredConnectors = searchedConnectors.filter(connector => {
    if (filter === 'View All') {
      return true;
    }

    return connector?.display?.marketingCategories?.some(category => category.toLowerCase() === filter.toLowerCase());
  });

  setResultMax(filteredConnectors.length);

  if (filteredConnectors.length > resultCount) {
    filteredConnectors.splice(resultCount);
  }

  return filteredConnectors;
};

export default useFilteredConnectors;
